import React from 'react';
import { parseJSON } from '../utils/string';
import { downloadFileWithName } from '../utils';
import { addNotification } from '../utils/notifications';
import exportApi from '../api/export';
import store from '../redux/store';
import WSClient from '../ws/WSClient';

class ExportService {
  jobId = null;
  reqParams = null;
  wsClient = null;
  onFinish = null;
  isExportRunning = false;
  
  startExport(reqParams) {
    this.isExportRunning = true;
    this.reqParams = reqParams;
    
    const topic = {
      name: '/topic/reportJob',
      handler: this.onMessage,
    };
  
    this.wsClient = new WSClient({
      url: `${process.env.REACT_APP_URL_API}sockets`,
      topics: [topic],
      onConnect: this.onConnect,
    });
  
    this.wsClient.activate();
  }
  
  finishExport() {
    this.wsClient.deactivate();
    this.isExportRunning = false;
    
    if (this.onFinish) {
      this.onFinish();
    }
  
    this.wsClient = null;
    this.onFinish = null;
    this.jobId = null;
    this.reqParams = null;
  }
  
  errorNotification(errorMsg) {
    addNotification('danger', errorMsg, 'Export Error', 10000);
  }
  
  onConnect = () => {
    store.dispatch(exportApi.endpoints.exportReport.initiate(this.reqParams))
      .unwrap()
      .then(res => {
        const jobId = res.jobId;
        const startMsg = (
          <>
            <div>Export has already started</div>
            <div>It may take some time</div>
          </>
        );
      
        this.jobId = jobId;
        addNotification('success', startMsg, 'Success', 5000);
      })
      .catch(error => {
        this.finishExport();
        this.errorNotification(error.message);
      });
  }
  
  onMessage = (message) => {
    const body = parseJSON(message.body);
  
    if (body) {
      const wsJobId = body.jobId;
      const wsStatus = body.status;
    
      if (wsJobId === this.jobId) {
        if (wsStatus === 'COMPLETED') {
          store.dispatch(exportApi.endpoints.downloadReport.initiate(wsJobId))
            .unwrap()
            .then(res => {
              const headers = res.headers;
              const report = res.report;
              const contentDisposition = headers['content-disposition'];
              const fileName = contentDisposition.split(';')[1].split('=')[1];
            
              downloadFileWithName(report, 'application/zip', fileName);
              addNotification('success', 'Export Completed', 'Success', 3000);
            })
            .catch(error => {
              const errorMsg = (
                <>
                  <div>Unable to download report file</div>
                  <div>{error.message}</div>
                </>
              );
            
              this.errorNotification(errorMsg);
            })
            .finally(() => {
              this.finishExport();
            });
        } else if (wsStatus === 'FAILED') {
          const failedMsg = (
            <>
              <div>Report generation failed</div>
              <div>Export cancelled</div>
            </>
          );
        
          this.finishExport();
          this.errorNotification(failedMsg);
        }
      }
    }
  }
}

export default new ExportService();
